// extracted by mini-css-extract-plugin
export default {"errorMessage":"MyTextInput_errorMessage__IQJoK"};